import * as React from 'react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'
import { Label } from '../ui/label'
import FlashAlert from './FlashAlert'

interface IProps {
	title: string
	description: string
	emailLabel: string
	emailFieldName: string
	emailValue?: string
	submitLabel: string
	alreadyHaveAccountLabel: string
	logInLabel: string
	logInUrl: string
	flashMessage?: string
	flashType?: string
}

export default function PasswordFormFields({
	title,
	description,
	emailLabel,
	emailFieldName,
	emailValue,
	submitLabel,
	alreadyHaveAccountLabel,
	logInLabel,
	logInUrl,
	flashMessage,
	flashType,
}: IProps) {
	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-col items-center gap-2 text-center">
				<h1 className="text-2xl font-bold">{title}</h1>
				<p className="text-balance text-muted-foreground">{description}</p>
			</div>

			<FlashAlert message={flashMessage} type={flashType} />

			<div className="flex flex-col gap-2">
				<Label htmlFor="password_email">{emailLabel}</Label>
				<Input
					id="password_email"
					name={emailFieldName}
					type="email"
					defaultValue={emailValue}
					autoComplete="off"
					required
				/>
			</div>

			<Button type="submit" className="w-full">
				{submitLabel}
			</Button>

			<p className="text-center text-sm text-muted-foreground">
				{alreadyHaveAccountLabel}{' '}
				<a href={logInUrl} className="underline underline-offset-4">
					{logInLabel}
				</a>
			</p>
		</div>
	)
}
